export const PAYSEND_PLUS = 'PAYSEND_PLUS';

// Subscription statuses
export const SUBSCRIBED = 'SUBSCRIBED';
export const UNSUBSCRIBED = 'UNSUBSCRIBED';
export const PAYMENT_PENDING = 'PAYMENT_PENDING';
export const REPAYMENT_MISSED = 'REPAYMENT_MISSED';
export const PAUSED = 'PAUSED';

// Subscription payment methods
export const CARD_TO_SUBSCRIPTION = 'CARD_TO_SUBSCRIPTION';
export const FREE_TO_SUBSCRIPTION = 'FREE_TO_SUBSCRIPTION';
export const GA_POCKET_TO_SUBSCRIPTION = 'GA_POCKET_TO_SUBSCRIPTION';

// Subscription payment methods
export const ONE_MONTH_SUBSCRIPTION = '1_MONTH_SUBSCRIPTION';
export const THREE_MONTHS_SUBSCRIPTION = '3_MONTH_SUBSCRIPTION';

// Subscription screens
export const PLAN_ID_LIST_SCREEN = 'PLAN_ID_LIST_SCREEN';
export const PAYMENT_METHOD_SCREEN = 'PAYMENT_METHOD_SCREEN';

export const isSubscriptionUpdateRestricted = (date) => {
    if (date) {
        const now = new Date();
        const subscriptionEnd = new Date(date);
        const restrictionStart = subscriptionEnd.setHours(subscriptionEnd.getHours() - 24);
        return now >= restrictionStart;
    }
};
